module.exports = __webpack_public_path__ + "static/media/shuttle_only.f1dbe115.png";